import Immutable from 'immutable';
import { actionTypes } from '../constants/myPagesConstants';

export const $$initialState = Immutable.fromJS({
  // devToolsOn: true,
  setIsFetching: false,
  setIsSaving: false,
  $$tree: [],
});

export default function myPagesReducer(
  $$state = $$initialState,
  action = null
) {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.MY_PAGES_CREATE_FOLDER_PAGE_SUCCESS: {
      const folderIndex = $$state
        .get('$$tree')
        .findIndex($$node => $$node.get('id') === payload.page.folder_page_id);
      return $$state
        .updateIn(['$$tree', folderIndex, 'children'], $$pages =>
          $$pages.push(Immutable.fromJS(payload.page))
        )
        .merge({
          setIsSaving: false,
        });
    }

    case actionTypes.MY_PAGES_CREATE_PAGE_SUCCESS: {
      return $$state
        .update('$$tree', $$tree => $$tree.push(Immutable.fromJS(payload.page)))
        .merge({
          setIsSaving: false,
        });
    }

    case actionTypes.MY_PAGES_CREATE_PAGE_FAILURE: {
      return $$state.merge({
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_DELETE_PAGE_FAILURE: {
      return $$state.merge({
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_DELETE_PAGE_SUCCESS: {
      // const deleteIndex = $$state.get('$$tree').findIndex($$node => $$node.get('id') === payload.id);
      return $$state.merge({
        $$tree: Immutable.fromJS(payload.tree),
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_EDIT_DIRECT_LINK_MODAL_REQUEST_CLOSE: {
      return $$state.merge({
        updateDirectLinkPageError: null,
      });
    }

    case actionTypes.MY_PAGES_INITIALIZE_FAILURE: {
      return $$state.merge({
        // setIsFetching: false,
      });
    }

    case actionTypes.MY_PAGES_INITIALIZE_SUCCESS: {
      return $$state.merge({
        $$tree: Immutable.fromJS(payload.tree),
        setIsFetching: false,
      });
    }

    case actionTypes.MY_PAGES_UNMOUNT: {
      return $$initialState;
    }

    case actionTypes.MY_PAGES_UPDATE_FOLDER_TITLE_SUCCESS: {
      return $$state.merge({
        $$tree: Immutable.fromJS(payload.tree),
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_UPDATE_FOLDER_TITLE_FAILURE: {
      return $$state.merge({
        // updateFolderTitleError: payload.error,
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_UPDATE_DIRECT_LINK_PAGE_SUCCESS: {
      // find index of node to update
      return $$state.merge({
        setIsSaving: false,
        $$tree: Immutable.fromJS(payload.tree),
      });
    }

    case actionTypes.MY_PAGES_UPDATE_DIRECT_LINK_PAGE_FAILURE: {
      return $$state.merge({
        updateDirectLinkPageError: payload.error,
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_UPDATE_PAGE_SUCCESS: {
      return $$state.merge({
        $$tree: Immutable.fromJS(payload.tree),
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_UPDATE_PAGE_FAILURE: {
      return $$state.merge({
        // updatePageError: payload.error,
        setIsSaving: false,
      });
    }

    case actionTypes.MY_PAGES_IS_FETCHING: {
      return $$state.merge({
        setIsFetching: true,
      });
    }

    case actionTypes.MY_PAGES_IS_SAVING: {
      return $$state.merge({
        setIsSaving: true,
      });
    }

    default: {
      return $$state;
    }
  }
}
